import React, { useContext, useState } from "react";
import { ModalContext } from "../../context/ModalContext";
import { CourseAccessesContext } from "../../context/CourseAccessesContext";
import { CoursesContext } from "../../context/CoursesContext";

const ChooseFinalExamModal = ({ course_id, accesses }) => {
  const [finalExam, setFinalExam] = useState(null);
  const [loading, setLoading] = useState(false);

  const { putCourseAccess } = useContext(CourseAccessesContext);
  const { getCourse } = useContext(CoursesContext);
  const { alert, success, clearModal } = useContext(ModalContext);

  const handleSubmit = () => {
    if (finalExam === null) {
      return alert("Debes seleccionar una disciplina para tu examen final");
    }
    setLoading(true);
    // the flag goes on the access of the chosen discipline, not the viewed one
    putCourseAccess(
      {
        course_access_id: finalExam.course_access_id,
        // final_exam: finalExam.course.name,
        chose_final_exam: true,
      },
      () => {
        success("Has seleccionado la disciplina de tu examen final");
        getCourse(course_id);
        clearModal();
      }
    );
  };

  return (
    <div>
      <p className="large">
        Has completado exitosamente todos los módulos de las {accesses.length}{" "}
        disciplinas incluidas en tu certificación.
      </p>
      <p className="text-primary large">
        Ahora selecciona la disciplina con la que deseas presentar tu examen
        final.
      </p>
      <div className="container-fluid px-0 py-2 mb-2">
        <p className="bold mb-2">Elige una disciplina:</p>
        {accesses.map((access) => (
          <label key={access.course_access_id} className="d-block mb-2">
            <input
              type="radio"
              name="final_exam"
              className="d-inline-block me-2"
              checked={
                finalExam !== null &&
                finalExam.course_access_id === access.course_access_id
              }
              onChange={() => setFinalExam(access)}
            />
            {access.course.name}
          </label>
        ))}
      </div>
      <p className="bold text-primary large mb-3">
        <span className="bold">Importante:</span> una vez confirmada tu
        selección, no podrá modificarse.
      </p>
      <div className="row">
        <div className="col-6">
          <button
            onClick={clearModal}
            disabled={loading}
            className="btn btn-link text-muted w-100"
          >
            Cancelar
          </button>
        </div>
        <div className="col-6">
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="btn btn-primary w-100"
          >
            {loading ? (
              <div className="spinner-border spinner-border-sm" />
            ) : (
              "Confirmar selección"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChooseFinalExamModal;
